import { loadItemAttachment } from './actions/publicActions';
import SxSReadingPaneStrategy, {
    SxSReadingPaneInitializeMethod,
} from './types/SxSReadingPaneStrategy';
import insertSxSV2IntoDomHelper from './utils/insertSxSV2IntoDomHelper';
import { LazyAction, LazyModule } from 'owa-bundling';
import { PreviewPaneSelectionSource } from 'owa-preview-pane-store';

const lazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "AttachmentPreviewSxS" */ './lazyIndex')
);

// Lazy actions
export const lazyPreviewAttachment = new LazyAction(lazyModule, m => m.previewAttachment);
export const lazyPreviewAttachmentInNewSxS = new LazyAction(
    lazyModule,
    m => m.previewAttachmentInNewSxS
);
export const lazyPreviewAttachmentInSxS = new LazyAction(lazyModule, m => m.previewAttachmentInSxS);
export const lazyPreviewImageInNewSxS = new LazyAction(lazyModule, m => m.previewImageInNewSxS);
export const lazyPreviewImageInSxS = new LazyAction(lazyModule, m => m.previewImageInSxS);
export const lazyPreviewLinkInNewSxS = new LazyAction(lazyModule, m => m.previewLinkInNewSxS);

export {
    insertSxSV2IntoDomHelper,
    loadItemAttachment,
    PreviewPaneSelectionSource,
    SxSReadingPaneInitializeMethod,
    SxSReadingPaneStrategy,
};
